import { DataResponse, MockAxiosResponse } from "utils/commonModels";

export function mockApiReturner<T>(input: T): Promise<MockAxiosResponse<DataResponse<T>>> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const res: DataResponse<T> = {
        statusCode: 200,
        body: {
          data: input,
          errorCode: 0,
          message: null,
          errors: null,
        },
      }
      const returnData: MockAxiosResponse<DataResponse<T>> = {
        config: {},
        headers: {},
        request: {},
        data: res,
        status: 200,
        statusText: "OK",
      };
      resolve(returnData);
    }, 1000);
  });
}
